// online 配置文件
export const CONFIG = {
	ENV_TEST: false,
	BASE_URL:'https://api-admin.mayizhuxue.com',
	OR_CODE_URL:'https://api-user.mayizhuxue.com/api/transferH5'
}
